<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Varegruppe" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<string-view label="Navn" v-model="entity.label" />
					<string-view label="Moms" v-model="entity.vat" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Type" v-model="entity.type" :options="[
						{
							value: 'default',
							label: 'Tjenester'
						},
						{
							value: 'product',
							label: 'Produkter'
						},
						{
							value: 'loan',
							label: 'Produkter (udlån)'
						},
						{
							value: 'free',
							label: 'Produkter (leveres)'
						}
					]"/>
				</div>
				<div v-show="active == 'details'">
					<div class="side-window__heading">
						Tillæg
						<switch-view v-model="entity.extra" />
					</div>
					<string-view v-show="entity.extra" label="Label" v-model="entity.extra_label" />
					<string-view v-show="entity.extra" label="Procent" v-model="entity.extra_multiplier" />
				</div>
			</form-grid-layout>
		</div>
		<div v-if="!id" slot="footer">
			<button-view label="Opret" @click="create" />
		</div>
		<div v-if="form && id" slot="footer">
			<button-view label="Gem" @click="update" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';

	export default {
		data() {
			return {
				entity: {
					label: null,
					vat: '25%',
					packaging: false,
					type: 'default',
					extra: false,
					extra_label: '',
					extra_multiplier: 1
				},
				active: 'details'
			};
		},
		components: {
			'TextView': TextView,
			'StringView': StringView
		},
		computed: {
			_roles() {
				var r = {};
				var role;
				var props;
				var prop;

				for (var i = 0; i < this.roles.length; ++i) {
					role = this.roles[i];
					props = {};
					
					for (var j = 0; j < role.props.length; ++j) {
						prop = role.props[j];
						props[prop.name] = prop.default;
					}

					r[role.name] = {
						enabled: false,
						props: props
					};
				}

				return r;
			},
			tabs: function () {
				if (this.id) {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						}
						/*{
							name: 'contacts',
							label: 'Contacts'
						}*/
					];
				} else {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						}
					];
				}
			}
		},
		props: {
			id: Number,
			form: Boolean,
			onCreate: {
				type: Function,
				default: function () {}
			},
			onUpdate: {
				type: Function,
				default: function () {}
			},
			onChange: {
				type: Function,
				default: function () {}
			}
		},
		methods: {
			invoiceSelect(name, id, label) {
				
				
				

				this.input(name, id);
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			create() {
				var win = this;

				
				

				this.axios
					.post('/product-groups/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});		
			},
			update() {
				
				

				var win = this;

				this.axios
					.put('/product-groups/' + this.id + '/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			input(name, value) {
				this.entity[name] = value;
			}
		},
		mounted: function() {
			
			

			var self = this;

			if (this.id) {
				this.axios
					.get('/product-groups/' + this.id + '/')
					.then(function (r) {
						self.entity = r.data;
						self.entity.roles = {...self._roles, ...self.entity.roles};
					});
			}
		}
	}
</script>

<style lang="scss">
	
</style>
